import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function WizardFooter({
  backDisabled = false,
  nextDisabled = false,
  onBack,
  onNext,
  isReviewStep = false,
  nextLabel,
  disabledHint = "",
}) {
  const showBack = !!onBack && !backDisabled;
  const disableNext = !!nextDisabled;

  return (
    <Box
      sx={{
        pt: 2,
        borderTop: (t) => `1px solid ${t.palette.divider}`,
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
      }}>
      {/* Back on the left; only show if there's a previous step */}
      {showBack ? (
        <Button
          variant="text"
          color="secondary"
          onClick={onBack}
          sx={{
            fontWeight: 600,
            color: (t) => t.palette.text.secondary,
            "&:hover": {
              color: (t) => t.palette.text.primary,
              background: "transparent",
            },
          }}>
          Back
        </Button>
      ) : (
        // spacer to keep Next aligned right even when Back is hidden
        <Box />
      )}

      {/* Next on the right + optional disabled hint below */}
      <Box
        sx={{
          ml: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onNext}
          disabled={disableNext}
          sx={{
            px: 3,
            borderRadius: 2,
            boxShadow: "none",
            "&:hover": { boxShadow: 2 },
          }}>
          {nextLabel ?? (isReviewStep ? "Go To Pay" : "Next")}
        </Button>

        {disableNext && disabledHint ? (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 0.75, textAlign: "right" }}>
            {disabledHint}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}
